module.exports = __webpack_public_path__ + "img/ellipse-inside-blur-blue.fc8db557.svg";